import { ICommonInsuranceParams } from '@app/pages/quote/insurance/insurance-model';
import { TaxType } from '@app/pages/quote/open-quote/model/open-quote.model';
import { calculateDto, customerDto, FinancialProductEnum } from '@app/pages/quote/standard-quote/model/standard-quote.model';
import { InsuranceTypeEnum } from '@app/services/insurance.service';

export class DirectCreditInsuranceStandard {
  nameCompany: string;
  financialProduct: string;
  currency: string;
  calculationType: string;
  maturityType: string;
  quantity: number;
  insuranceAmount: number;
  unitPrice: number;
  confirmationExpensesAmount: number | null;
  term: number;
  taxFree: boolean;
  customerRate: number;
  downPaymentTaxType: string;
  downPaymentTax: number | null;
  downPayment: number;
  openingFeeType: string;
  openingFeePercentage: number | null;
  openingFee: number | null;
  gracePeriodApplyTo: any;
  gracePeriod: any;
  specialPayments: any;
  grace: any;
  irregularPayments: any;
  personType: any;
  lifeInsuranceAmount: number;
  financialSetupId: any;
  financialConditionId: any;
  purchasePercentage: any;
  residualValuePercentage: any;

  constructor(form: any, params: ICommonInsuranceParams, customer: customerDto | null, data: any) {
    const insuranceType = form.insuranceType;
    const isAnnualInsurance = insuranceType === InsuranceTypeEnum.COUNTED_ANNUAL || insuranceType === InsuranceTypeEnum.FINANCED_ANNUAL;
    const isTermMoreThan12 = data.financialSetup.financialCondition.term > 12;
    const marshTerm = isAnnualInsurance && isTermMoreThan12 ?  12 :  data.financialSetup.financialCondition.term;
    this.personType = customer?.personType;
    this.nameCompany = params.companyName;
    this.financialProduct = FinancialProductEnum.directCredit;
    this.currency = params?.currency || "";
    this.calculationType = params?.paymentFormationType || "";
    this.maturityType = params?.paymentType || "";
    this.quantity = params?.quantity!;
    this.insuranceAmount = 0;
    this.unitPrice = form?.packageList?.amount;
    this.confirmationExpensesAmount = 3886;
    this.lifeInsuranceAmount = 0;
    // Anual financiado como maximo 12 meses
    this.term = marshTerm;
    // Convertir taxFree a boolean (puede venir como string "true"/"false" o boolean)
    const taxFreeValue = data.financialSetup?.taxFree;
    this.taxFree = taxFreeValue === true || taxFreeValue === "true" || taxFreeValue === "TRUE" || false;
    this.customerRate = data.financialSetup.financialCondition.nominalRate;
    this.downPaymentTaxType = TaxType.fixedAmount;
    this.downPaymentTax = null;
    this.downPayment = 0;
    this.openingFeeType = data.financialSetup.openingFeeType;
    this.openingFeePercentage = data.financialSetup.openingFeeTax;
    this.openingFee = data.financialSetup.openingFee;
    this.gracePeriodApplyTo = 'CAPITAL';
    this.gracePeriod = 1;
    this.specialPayments = null;
    this.grace = data.grace;
    this.irregularPayments = null;

    this.financialSetupId = data.financialSetup.id;
    this.financialConditionId = data.financialSetup.financialCondition.id;
    this.purchasePercentage = null;
    this.residualValuePercentage = null;
  }
}
